const styles = theme => ({
  accordion: {
    width: '100%',
    padding: '0',
    margin: '0 !important',
    boxShadow: 'none',
    borderRadius: '0 !important',
  },
  expandedAccordion: {},
  accordionSummary: {
    width: '100%',
    minHeight: 'auto !important',
    minWidth: 'auto !important',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    '& .MuiAccordionSummary-content': {
      margin: '0',
    },
    '& .MuiAccordionSummary-expandIcon': {
      padding: '0',
      margin: '0',
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.adgmBlack,
      },
      '& .MuiTouchRipple-root': {
        display: 'none',
      },
    },
  },
  accordionHeading: {
    color: '#2F3239',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '21px',
  },
  accordionDetails: {
    display: 'block',
    padding: '8px 0 0 0',
    width: '100%',
  },
  textADGMRed: {
    color: theme.palette.primary.main + '!important',
  },
});

export default styles;
